// src/environments/production.ts
import environment from "./base";
const baseApi = "//www.dreamchimney.com";
const baseApiLambda = "https://31hlhgppde.execute-api.us-west-2.amazonaws.com/dev";
const baseApiTracks = `https://www.dreamchimney.com/api`;
const env = environment(baseApi, baseApiLambda, baseApiTracks);
export default {
  ...env,
};
